<template>
    <div class="sd-modal">
      <div class="modal-shade"></div>
      <div class="modal-content" ref="content">
        <slot></slot>
      </div>
    </div>
</template>

<script type="es6">
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { util } from '../service/util'
    export default {
        name:'sd-modal',
        props: ['left','top'],
        data () {
            return {
                
            }
        },
        computed: {
            
        },
        methods: {
            
        },
        updated(){
          // 居中
          let content = this.$refs.content,
              cH = content.offsetHeight,
              cW = content.offsetWidth,
              wH = document.documentElement.clientHeight,
              wW = document.documentElement.clientWidth;
          $(content).css({
            'left': '50%',
            'top':  '48%',
            'margin-left': -cW/2+'px',
            'margin-top' : -cH/2+'px'
          })
        },
        created(){
            
        }
    }
</script>

<style lang="scss">
  .sd-modal {
    .modal-shade {
      position: fixed;
      z-index: 99;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: #000;
      opacity: 0.5;
    }
    .modal-content {
      
      margin: auto;
      position: fixed;
      opacity: 1;
      z-index: 110000;
    }
  }
</style>


// WEBPACK FOOTER //
// sdModal.vue?7667351e